<template>
    <b-modal id="modal-encuesta" centered button-size="sm" no-close-on-esc no-close-on-backdrop
        modal-class="modal-modern survey-modal">
        <template #modal-header>
            <div class="survey-header">
                <div class="survey-heading">
                    <div class="survey-mark" aria-hidden="true">
                        <i class="ri-chat-heart-line"></i>
                    </div>
                    <div>
                        <h2>Tu experiencia importa</h2>
                    </div>
                </div>
                <button class="survey-skip" type="button" @click="procesarEncuesta()">
                    Omitir
                    <i class="ri-close-line" aria-hidden="true"></i>
                </button>
            </div>
        </template>

        <div class="survey-content">
            <div class="survey-class-summary">
                <div class="survey-class-details">
                    <div class="survey-class-detail">
                        <i class="ri-map-pin-line" aria-hidden="true"></i>
                        <span class="survey-detail-copy">
                            <span class="survey-detail-label">Sede</span>
                            <strong>{{ agendamiento.sede.nombre }}</strong>
                        </span>
                    </div>
                    <div class="survey-class-detail">
                        <i class="ri-time-line" aria-hidden="true"></i>
                        <span class="survey-detail-copy">
                            <span class="survey-detail-label">Hora</span>
                            <strong>{{ agendamiento.hora }}</strong>
                        </span>
                    </div>
                    <div class="survey-class-detail survey-teacher-detail">
                        <i class="ri-user-line" aria-hidden="true"></i>
                        <span class="survey-detail-copy">
                            <span class="survey-detail-label">Profesor</span>
                            <strong>{{ agendamiento.clase.profesor.primer_nombre }} {{ agendamiento.clase.profesor.primer_apellido }}</strong>
                        </span>
                    </div>
                </div>
            </div>

            <section v-if="paso === 1" class="survey-step survey-rating-step">
                <div class="survey-question">
                    <h3>¿Cómo te sentiste en esta clase?</h3>
                    <p>Elige la expresión que mejor describe tu experiencia.</p>
                </div>

                <b-form-group class="survey-rating-group">
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="encuesta.calificacion"
                        class="survey-rating"
                        name="radios-btn-default"
                        aria-label="Califica tu clase del 1 al 5"
                        buttons>
                        <b-form-radio
                            v-for="option in options"
                            :key="option.value"
                            :value="option.value"
                            :aria-label="`${option.value} de 5: ${option.description}`"
                            class="rating-choice"
                            :class="{ 'rating-choice-excellent': option.value === '5' }">
                            <span class="rating-face">
                                <b-icon :icon="option.icon" :class="option.class"></b-icon>
                            </span>
                            <span class="rating-description">{{ option.description }}</span>
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

            </section>

            <section v-if="paso === 2" class="survey-step survey-comment-step">
                <div class="survey-comment-intro">
                    <div>
                        <span class="survey-kicker">Tu voz suma</span>
                        <h3>¿Quieres dejar una observación?</h3>
                        <p>Comparte una idea, sugerencia o algo que te haya gustado.</p>
                    </div>
                </div>

                <b-form-textarea
                    id="textarea"
                    v-model="encuesta.comentarios"
                    :maxLength="comentariosMax"
                    class="survey-textarea"
                    placeholder="Escribe aquí tu comentario..."
                    rows="4"
                    aria-label="Observación sobre la clase"
                    @keypress="isLetter($event)"
                    @change="reviewTextChange($event)"
                    @paste.prevent>
                </b-form-textarea>
                <div class="survey-comment-meta">
                    <span>Máximo {{ comentariosMax }} caracteres</span>
                    <span class="survey-character-count" :class="{ 'near-limit': encuesta.comentarios.length >= comentariosMax - 20 }">
                        {{ encuesta.comentarios.length }}<span> / {{ comentariosMax }}</span>
                    </span>
                </div>
            </section>
        </div>

        <template #modal-footer>
            <div class="survey-footer">
                <span class="survey-footer-note">
                    <i class="ri-lock-line" aria-hidden="true"></i>
                    Tu respuesta nos ayuda a mejorar
                </span>
                <b-button
                    v-if="paso === 1"
                    variant="primary"
                    class="survey-primary-action"
                    @click="siguiente"
                    :disabled="!encuesta.calificacion">
                    Continuar
                    <i class="ri-arrow-right-line" aria-hidden="true"></i>
                </b-button>
                <b-button
                    v-if="paso === 2"
                    variant="primary"
                    class="survey-primary-action"
                    @click="procesarEncuesta">
                    Enviar respuesta
                    <i class="ri-send-plane-2-line" aria-hidden="true"></i>
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import utils from '@/modules/utils';

export default {
    name: 'EncuestaClase',
    data() {
        return {
            paso:1,
            sede_id:null,
            comentariosMax: 150,
            encuesta:{
                agendamiento_id:null,
                omitir:null,
                calificacion:null,
                comentarios:"",
            },
            options: [
                { icon: 'emoji-angry-fill', value: '1', description: 'Muy mala', class:"h1 red" },
                { icon: 'emoji-frown-fill', value: '2', description: 'Mala', class:"h1 yellow-orange" },
                { icon: 'emoji-neutral-fill', value: '3', description: 'Regular', class:"h1 yellow"},
                { icon: 'emoji-smile-fill', value: '4', description: 'Buena', class:"h1 green-yellow" },
                { icon: 'emoji-heart-eyes-fill', value: '5', description: 'Excelente', class:"h1 green" }
            ],
            paso:1
        }
    },
    props:{
        agendamiento: Object,
        mostrar: Boolean
    },
    mounted () {
        this.showModal();
    },
    methods:{
        ...mapActions({
            saveEncuesta: 'academico/saveEncuesta',
        }),
        ...mapMutations({
            setShowNotification: 'setShowNotification'
        }),
        showModal() {
            this.encuesta.agendamiento_id = this.agendamiento.id;
            this.$bvModal.show('modal-encuesta')
        },
        hideModal() {
            this.$bvModal.hide('modal-encuesta')
            this.$emit('cerrar');
        },
        procesarEncuesta() {
            this.saveEncuesta(this.encuesta).then((result) => {

            }).finally(() => {
                this.hideModal();
            })
        },
        siguiente() {
            this.paso = 2;
        },
        isLetter(e) {
          let char = String.fromCharCode(e.keyCode); // Get the character
          if(utils.LETTER_REGEX.test(char)) return true; // Match with regex 
          else e.preventDefault(); // If not match, don't add to input text
        },
        reviewText(event) {
            let char = String.fromCharCode(event.keyCode);
            if(!utils.LETTER_REGEX.test(char)) {
                this.encuesta.comentarios = utils.eliminarCaracteres(this.encuesta.comentarios);
            }
        },
        reviewTextChange(event) {
            if(!utils.LETTER_REGEX.test(this.encuesta.comentarios)) {
                this.encuesta.comentarios = utils.eliminarCaracteres(this.encuesta.comentarios);
            }
        }
    },
    computed:{
        ...mapState({
            user: state => state.auth.user,
        }),
        ...mapGetters({
        // getSede: 'sedes/getSede',
        }),
        validation() {
            return this.form.tipo_documento ? true : false
        },
        encuestaMostrar() {
            if (this.agendamiento && this.agendamiento.clase) {
                return true;
            }
            return false;
        }
    },
    watch: { 
        mostrar: function(newVal, oldVal) {
            if (newVal == true && this.encuestaMostrar) {
                this.showModal()
            }
        },
        // "encuesta.comentarios": function (old_val, new_val) {
        //     if(utils.LETTER_REGEX.test(new_val)) {
                
        //     }
        //     else {
                
        //     }
        // }
    }
}
</script>

<style>
#modal-encuesta {
    padding-left: 0 !important;
}
.survey-modal .modal-dialog {
    max-width: 580px;
}

.survey-modal .modal-content {
    overflow: hidden;
    background: var(--theme-bg-secondary);
    color: var(--theme-text-primary);
    border: 1px solid var(--theme-border-color);
    border-radius: 18px;
    box-shadow: var(--theme-shadow-xl);
}

.survey-modal .modal-header {
    display: block;
    padding: 0;
    border: 0;
    background: var(--theme-gradient-primary);
}

.survey-modal .modal-body {
    padding: 0;
    background: var(--theme-bg-secondary);
}

.survey-modal .modal-footer {
    padding: 1rem 1.5rem;
    border-top: 1px solid var(--theme-border-color);
    background: var(--theme-bg-secondary);
}

.survey-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0 1rem;
    color: #fff;
}

html.light-theme .survey-modal .modal-header {
    background: var(--theme-bg-tertiary);
    border-bottom: 1px solid var(--theme-border-color);
}

html.light-theme .survey-header {
    color: var(--theme-text-primary);
}

html.light-theme .survey-mark {
    border-color: var(--app-primary-blue);
    background: var(--theme-gradient-primary);
    color: #fff;
}

html.light-theme .survey-heading h2 {
    color: var(--theme-text-primary);
}

html.light-theme .survey-skip {
    border-color: var(--app-primary-blue);
    background: transparent;
    color: var(--app-primary-blue);
}

html.light-theme .survey-skip:hover {
    background: var(--theme-hover-bg-light);
}

.survey-heading {
    display: flex;
    align-items: center;
    gap: 0.9rem;
    min-width: 0;
}

.survey-mark {
    display: grid;
    place-items: center;
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    font-size: 1.55rem;
    animation: survey-mark-in 500ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.survey-heading h2,
.survey-question h3,
.survey-comment-intro h3 {
    margin: 0;
}

.survey-heading h2 {
    color: #fff;
    font-size: 1.2rem;
    font-weight: 700;
}

.survey-skip {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.45rem 0.65rem;
    flex: 0 0 auto;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    font: inherit;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 180ms ease, transform 180ms ease;
}

.survey-skip:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
}

.survey-skip:focus-visible,
.survey-primary-action:focus-visible,
.survey-rating .rating-choice:focus-within {
    outline: 3px solid var(--app-color-gold);
    outline-offset: 3px;
}

.survey-content {
    padding: 0 1rem;
}

.survey-step {
    animation: survey-step-in 360ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.survey-class-summary {
    display: flex;
    align-items: center;
    min-width: 0;
    margin-bottom: 1rem;
    padding: 0.65rem 0.75rem;
    border: 1px solid var(--theme-border-color);
    border-radius: 10px;
    background: var(--theme-bg-tertiary);
}

.survey-class-details {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: center;
    gap: 0.6rem;
    width: 100%;
    min-width: 0;
}

.survey-class-detail {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: 0.45rem;
    min-width: 0;
}

.survey-class-detail > i {
    color: var(--app-color-cyan-light);
    font-size: 1rem;
}

.survey-detail-copy {
    display: flex;
    flex-direction: column;
    gap: 0.08rem;
    min-width: 0;
}

.survey-detail-label {
    color: var(--theme-text-muted);
    font-size: 0.6rem;
    font-weight: 600;
    text-transform: uppercase;
}

.survey-class-detail strong {
    overflow: hidden;
    color: var(--theme-text-primary);
    font-size: 0.72rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.survey-question {
    padding: 0.55rem 0 0.8rem;
    text-align: center;
}

.survey-kicker {
    display: inline-block;
    margin-bottom: 0.35rem;
    color: var(--app-color-cyan-light);
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
}

.survey-question h3,
.survey-comment-intro h3 {
    color: var(--theme-text-primary);
    font-size: 1rem;
    font-weight: 700;
}

.survey-question p,
.survey-comment-intro p {
    margin: 0.35rem 0 0;
    color: var(--theme-text-secondary);
    font-size: 0.84rem;
    line-height: 1.5;
}

.survey-rating-group {
    margin: 0;
}

.survey-rating {
    display: grid !important;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    align-items: start;
    gap: 0.45rem;
    width: 100%;
}

.survey-rating .rating-choice {
    display: flex;
    min-width: 0;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 0.42rem;
    padding: 0.35rem 0.1rem;
    border: 1px solid transparent;
    border-radius: 10px !important;
    background: transparent;
    color: var(--theme-text-secondary);
    transition: color 180ms ease, background-color 180ms ease, border-color 180ms ease;
}

.survey-rating .rating-choice:hover:not(.active) {
    border-color: transparent;
    background: transparent;
}

.rating-face {
    display: grid;
    place-items: center;
    width: 50px;
    height: 50px;
    font-size: 2.15rem;
    transform-origin: center bottom;
    transition: transform 200ms cubic-bezier(0.2, 0.8, 0.2, 1), filter 200ms ease;
}

.rating-description {
    color: var(--theme-text-secondary);
    font-size: 0.7rem;
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
}

.survey-rating .rating-choice:hover .rating-face,
.survey-rating .rating-choice:focus-within .rating-face {
    transform: translateY(-5px) rotate(-8deg) scale(1.15);
    filter: drop-shadow(0 4px 5px rgba(0, 0, 0, 0.16));
}

.survey-rating .rating-choice-excellent .rating-face {
    animation: excellent-soft-glow 3s ease-in-out infinite;
}

.survey-rating .rating-choice-excellent:hover .rating-face,
.survey-rating .rating-choice-excellent:focus-within .rating-face,
.survey-rating .rating-choice-excellent.active .rating-face {
    animation: none;
}

.survey-rating .rating-choice.active {
    border-color: var(--app-primary-blue) !important;
    background: var(--theme-bg-tertiary) !important;
    color: var(--theme-text-primary) !important;
    box-shadow: 0 0 0 2px var(--theme-input-focus) !important;
}

label.btn-secondary:focus, label.btn-secondary:active{
    color: var(--theme-text-primary) !important;
    background-color: var(--theme-bg-tertiary) !important;
    border-color: var(--app-primary-blue) !important;
    box-shadow: 0 0 0 2px var(--theme-input-focus) !important;
}

.survey-rating .rating-choice.active .rating-face {
    transform: scale(1.06);
    filter: none;
}

.survey-rating .rating-choice.active .rating-description {
    color: var(--app-primary-blue);
}

html.dark-theme .survey-rating .rating-choice.active .rating-description {
    color: var(--theme-text-primary);
}

.survey-comment-intro {
    display: flex;
    align-items: flex-start;
    gap: 0.8rem;
    margin: 0.5rem 0 1.1rem;
}

.comment-icon {
    width: 42px;
    height: 42px;
    flex-basis: 42px;
    background: var(--theme-gradient-success);
    color: #fff;
}

.survey-comment-intro .survey-kicker {
    margin-bottom: 0.2rem;
}

.survey-textarea {
    min-height: 130px;
    padding: 0.85rem 0.95rem;
    border: 1px solid var(--theme-input-border);
    border-radius: 10px;
    background: var(--theme-input-bg);
    color: var(--theme-text-primary);
    line-height: 1.55;
    resize: vertical;
    transition: border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
}

.survey-textarea::placeholder {
    color: var(--theme-text-muted);
}

.survey-textarea:focus {
    border-color: var(--app-primary-blue);
    background: var(--theme-bg-secondary);
    color: var(--theme-text-primary);
    box-shadow: 0 0 0 3px var(--theme-input-focus);
}

.survey-comment-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 0.55rem;
    color: var(--theme-text-muted);
    font-size: 0.72rem;
}

.survey-character-count {
    color: var(--theme-text-secondary);
    font-weight: 700;
    font-variant-numeric: tabular-nums;
}

.survey-character-count span {
    color: var(--theme-text-muted);
    font-weight: 500;
}

.survey-character-count.near-limit {
    color: var(--theme-color-warning);
}

.survey-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
}

.survey-footer-note {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    color: var(--theme-text-muted);
    font-size: 0.72rem;
}

.survey-footer-note i {
    color: var(--theme-color-success);
}

.survey-primary-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.55rem;
    min-height: 42px;
    padding: 0.6rem 1rem;
    border: 0;
    border-radius: 9px;
    background: var(--theme-gradient-primary) !important;
    color: #fff !important;
    font-size: 0.84rem;
    font-weight: 700;
    box-shadow: var(--theme-shadow-sm);
    transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
}

.survey-primary-action:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: var(--theme-shadow-md);
}

.survey-primary-action:disabled {
    opacity: 0.48;
    cursor: not-allowed;
}

.red {
    color: var(--theme-color-danger) !important;
}

.yellow-orange {
    color: var(--app-color-peach) !important;
}

.yellow {
    color: var(--theme-color-warning) !important;
}

.green-yellow {
    color: var(--theme-color-success-light) !important;
}

.green {
    color: var(--theme-color-success) !important;
}

@keyframes survey-mark-in {
    from { opacity: 0; transform: scale(0.82) rotate(-8deg); }
    to { opacity: 1; transform: scale(1) rotate(0); }
}

@keyframes survey-step-in {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes excellent-soft-glow {
    0%, 100% { filter: drop-shadow(0 0 0 rgba(5, 150, 105, 0)); }
    50% { filter: drop-shadow(0 2px 5px rgba(5, 150, 105, 0.28)); }
}

@media (max-width: 575.98px) {
    .survey-modal .modal-dialog {
        margin: 0.5rem;
    }

    .survey-header {
        align-items: flex-start;
        padding: 0;
    }

    .survey-heading {
        gap: 0.65rem;
    }

    .survey-mark {
        width: 42px;
        height: 42px;
        flex-basis: 42px;
    }

    .survey-heading h2 {
        font-size: 1rem;
    }

    .survey-skip {
        padding: 0.4rem;
        font-size: 0.75rem;
    }

    .survey-content {
        padding: 0;
    }

    .survey-rating {
        gap: 0.35rem;
    }

    .survey-rating .rating-choice {
        padding: 0.25rem 0.05rem;
    }

    .rating-face {
        width: 42px;
        height: 42px;
        font-size: 1.8rem;
    }

    .rating-description {
        font-size: 0.63rem;
    }

    .survey-class-details {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.55rem 0.7rem;
    }

    .survey-teacher-detail {
        grid-column: 1 / -1;
    }

    .survey-footer-note {
        display: none;
    }

    .survey-primary-action {
        width: 100%;
    }
}

@media (prefers-reduced-motion: reduce) {
    .survey-modal *,
    .survey-modal *::before,
    .survey-modal *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        scroll-behavior: auto !important;
        transition-duration: 0.01ms !important;
    }
}
</style>